<template>
	<router-link
        :to="unidade.status == 'ativo' ? ('/v1/unidades/' + unidade.id) : ''"
        class="text-center m-2"
        style="width: auto; border-radius: 10px"
    >
        <div class="card" :style="{ '--bg-image': `url(${getImageUrl(unidade.imagem)})`, boxShadow: unidade.status == 'ativo' ? '5px 4px 7px #9d9595' : '' }">
            <img :src="getImageUrl(unidade.logo)" :alt="unidade.nome" class="image" />
            <div class="card-nome">
                <span class="text-uppercase">{{unidade.nome}}</span>
            </div>
			<div v-if="unidade.status == 'inativo'" class="inativo-overlay">
				<span class="inativo-text">Desabilitada</span>
			</div>
        </div>
    </router-link>
</template>

<script>
	import { defineComponent } from "vue";

	export default defineComponent({
		props: {
			unidade: {
				type: Object,
				required: true,
			},
		},
        methods: {
            getImageUrl(imagePath) {
                return `${process.env.VUE_APP_SERVER}/storage/${imagePath}`;
            },
        },
	});
</script>

<style scoped>
	.card {
		width: 300px;
		height: 257px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		gap: 10px;
		background-color: #fffffe;
		border-radius: 15px;
		position: relative;
		overflow: hidden;
	}

	.card::before {
		content: "";
		width: 350px;
		height: 100px;
		position: absolute;
		top: 0;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		border-bottom: 3px solid #fefefe;
		background-image: var(--bg-image);
		background-size: cover;
		background-position: center;
	}

	.card * {
		z-index: 1;
	}

	.image {
		width: 90px;
		height: 90px;
		background: white;
		border-radius: 50%;
		margin-top: -10px;
		box-shadow: 0px 0px 12px #9d9595;

	}

	.card-nome {
		align-items: center;
		gap: 15px;
		margin-left: 1px;
		margin-right: 1px;
	}

	.card-nome span {
		font-weight: 600;
		color: green;
		margin-top: 15px;
		text-decoration: none; 
	}
	.button {
		text-decoration: none;
		background-color: #1468BF;
		color: white;
		padding: 5px 20px;
		border-radius: 5px;
		border: 1px solid white;
	}

	.inativo-overlay {
		position: absolute;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.75);
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: not-allowed;
	}

	.inativo-text {
		color: white;
		font-size: 1.5em;
		font-weight: bold;
		z-index: 3;
	}
</style>
